import { ComponentType } from 'react';
import { Navigate, useLocation } from 'react-router';

import { ReturnTo } from '@/helpers/redirectTo';
import { usePendingRedirect } from '@/hooks/usePendingRedirect';
import { useNewAuth } from '@/providers/AuthProvider/NewAuthProvider.hooks';
import { StyledPageLoader } from '@/components/StyledSharedComponents/StyledLoader';
import { ERoutes } from '@/types/routes';

export const SmartFallback = () => {
  const { isAuthenticated } = useNewAuth();
  const location = useLocation();
  const pending = usePendingRedirect();

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search + location.hash;
    if (redirectTo !== '/') {
      ReturnTo.set(redirectTo);
    }
    return <Navigate to={ERoutes.LOGIN} replace />;
  }

  if (pending) {
    return <StyledPageLoader />;
  }

  return <Navigate to={ERoutes.DASHBOARD} replace />;
};

interface IAuthFallbackProps {
  PageComponent: ComponentType;
}

export const AuthFallback = ({ PageComponent }: IAuthFallbackProps) => {
  const { isAuthenticated } = useNewAuth();
  const pending = usePendingRedirect();

  if (!isAuthenticated) {
    return <PageComponent />;
  }

  if (pending) {
    return <StyledPageLoader />;
  }

  return <Navigate to={ERoutes.DASHBOARD} replace />;
};
